module.exports = __webpack_public_path__ + "static/media/start-learning.b850ba8b.jpg";